module.exports = __webpack_public_path__ + "img/Logo.9f60674a.png";